<template>
  <div class="mapping">
    <div class="content">
      <div class="newtable-title">
        <div class="left-t">
          <span>映射管理</span>
        </div>
        <div class="btns">
          <el-button type="primary" @click="dialogAddress= true">地址管理</el-button>
          <el-button type="primary" @click="add_ed(0)">新增映射</el-button>
          <el-button type="primary" @click="exportList" class="last-el-button">导出</el-button>
        </div>

      </div>
      <div class="mapping-table">
        <el-table :data="tableData" v-loading="loading" stripe style="width: 100%" :height="heights">
          <el-table-column label="序号" width="90" align="center">
            <template slot="empty">
              <span class="noData">
                <img src="../../assets/noData.png" alt="暂无数据">
                <span class="text">暂无数据</span>
              </span>
            </template>
            <template slot-scope="scope">
              <span>{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="capacityName" label="映射名称" width="305"> </el-table-column>
          <el-table-column prop="measurement" label="计量单位" width="204"> </el-table-column>
          <el-table-column prop="localDevices" label="本地设备" width="306"> </el-table-column>
          <el-table-column prop="remotDevice" label="远程设备" width="306"> </el-table-column>
          <el-table-column label="创建时间" width="204">
            <template slot-scope="scope"><span>{{ scope.row.createTime | date_format}}</span></template>
          </el-table-column>
          <el-table-column label="启用" width="110" align="center">
            <template #default="{row}">
              <span>
                <!-- {{row.createTime}} -->
                <el-switch v-model="row.status" active-color="#409eff" inactive-color="#dcdfe6"
                  @change="switch_fn(row.status,row)"></el-switch>
              </span>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template #default="{row}">
              <span class="buttoned_box">
                <el-button type="text" @click="edit_ed(row)" style="color:#409eff;font-weight: bold">编辑</el-button>
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <downloadTable ref="downloadTable"></downloadTable>
    </div>

    <!-- 新增修改 -->
    <el-dialog width="40%" v-dialogDrag :title="textMap[dialogStatus]" :close-on-click-modal='false'
      :visible.sync="dialogVisible">
      <div style="display: flex;height: 512px">
        <div class="device-tree">
          <!-- <elRadioTree :dataList='virtualDeviceList' ref="elradiotree"></elRadioTree> -->
          <elCheckBoxTree ref="elradiotree" slot="tree" :dataList='virtualDeviceList' @checkItem="treeCheckItem">
          </elCheckBoxTree>
        </div>
        <el-form :model="temp" ref="temp" :rules="rules"
          style="border: 1px solid #ded7d7;width: 80%;height: 500px;padding-top: 10px;">
          <el-form-item label="映射名称:" prop="capacityName">
            <el-input v-model="temp.capacityName" style="width:300px"></el-input>
          </el-form-item>

          <el-form-item label="计量单位:" prop="measurement">
            <el-input v-model="temp.measurement" style="width:300px"></el-input>
          </el-form-item>
          <el-form-item label="本地设备:" prop="localDevices">
            <el-input v-model="temp.localDevices" disabled style="width:300px"></el-input>
          </el-form-item>
          <el-form-item label="远程设备:" prop="remotDevice">
            <el-input v-model="temp.remotDevice" style="width:300px"></el-input>
            <p style="color:red;font-size:12px">Tip：多个设备请用英文逗号隔开</p>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogStatus==='edit'?edit_fn('temp'):add_fn('temp')">保存</el-button>
      </div>
    </el-dialog>
    <!-- 远程地址管理 -->
    <el-dialog width="40%" v-dialogDrag title="地址管理" :close-on-click-modal='false' :visible.sync="dialogAddress">
      <div class="address">
        <el-form :model="remote" ref="remote" :rules="remRules" style="width: 90%;height: 50px;padding-top: 10px;">
          <el-form-item label="地址:" prop="remoteUrl" style="width:100%">
            <el-input v-model="remote.remoteUrl" style="width: 100%;margin-right:20px"></el-input>
            <el-button type="primary" v-if="remote.status == 'DISABLE' && remoteFlag" @click="remoteStatus('ENABLE')">启
              用</el-button>
            <el-button type="warning" v-if="remote.status == 'ENABLE' && remoteFlag" @click="remoteStatus('DISABLE')">禁
              用</el-button>
          </el-form-item>


        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogAddress = false">取 消</el-button>
        <el-button type="primary" @click="saveRemote">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {getMappingList,setMappingSave,mappingUpdate,mappingStatus,capacityFindById,capacitySaveRemote,capacityStatusRemote} from "../../api/capacity";
  import elRadioTree from '@/components/module/tree/elRadioTree.vue'
  import elCheckBoxTree from '@/components/module/tree/elCheckBoxTree.vue'
  import downloadTable from '@/components/module/downloadTable/downloadTable.vue'
  export default {
    components: {
      elRadioTree,
      elCheckBoxTree,
      downloadTable
    },
    data () {
      return {
        heights: document.getElementById('app').clientHeight-220,//屏幕高度 - 导航栏高度
        loading: true,
        dialogVisible: false,
        dialogAddress: false,
        dialogStatus: '',
        textMap: {
          add: "新增映射",
          edit: "编辑映射"
        },
        temp: {
          'capacityName': "",
          'localDevices': "",
          'localDeviceNos': ""
        },
        remote: {
          remoteUrl: ""
        },
        rules: {
          capacityName: [
            {required: true,message: '请输入映射名称',trigger: 'blur'}
          ],
          localDevices: [
            {required: true,message: '请选择能耗设备',trigger: 'blur'}
          ],
          remotDevice: [
            {required: true,message: '请选择EMS设备',trigger: 'blur'}
          ],
          measurement: [
            {required: true,message: '请输入产品单位',trigger: 'blur'}
          ],
        },
        remRules: {
          remoteUrl: [
            {required: true,message: '请输入远程地址',trigger: 'blur'}
          ],
        },
        tableData: [],
        remoteFlag: false
      };
    },

    mounted () {
      this.getList()
      this.remote_fn()

    },
    computed: {
      unitId () {
        return this.$store.unitStore.state.nowUnit
      },
      nowVirtualDevice () {
        return this.$store.deviceStore.state.nowVirtualDevice
      },
      virtualDeviceList () {
        var data=this.$store.deviceStore.getters.getReadDeviceTree
        return isempty(data)? []:[deviceList(data)]
      },
    },
    watch: {
      unitId () {
        this.getList() // 获取列表数据
        this.remote_fn() // 获取远程接口
      },
      nowVirtualDevice (nv) {
        this.temp.localDevices=nv.name
        this.temp.localDeviceNos=nv.no
      }
    },

    methods: {
      treeCheckItem (item) {

        var d=[]
        if(!item) {
          return
        }
        item.forEach(list => {
          if(list.type=='virtualDevice') {
            d.push(list)
          }
        })
        var name=[];
        var id=[];
        d.map(v => {
          name.push(v.name);
          id.push(v.id);
        });
        this.temp.localDevices=name.join(',')
        this.temp.localDeviceNos=id.join(',')
      },
      //获取数据
      getList () {
        var id=this.unitId.id
        this.loading=true
        getMappingList({'unitId': id}).then(res => {
          if(res.code==200) {
            this.tableData=res.data
            this.loading=false
            this.tableData.forEach(item => {
              if(item.status=='ENABLE') {
                item.status=true
              } else {
                item.status=false
              }
            })
          } else {
            this.loading=false
          }
        })
      },
      //获取远程接口
      remote_fn () {
        this.remote={}
        capacityFindById({'unitId': this.unitId.id}).then(res => {
          if(res.data) {
            this.remote=res.data
            this.remoteFlag=true
          } else {
            this.remote={}
            this.remoteFlag=false
          }
        })
      },
      //保存远程接口
      saveRemote () {
        this.$refs['remote'].validate(valid => {
          if(valid) {
            var d={
              remoteUrl: this.remote.remoteUrl,
              unitId: this.unitId.id
            }
            if(this.remoteFlag) {
              d.id=this.remote.id
            }
            capacitySaveRemote(d).then(res => {
              if(res.code==200) {
                this.dialogAddress=false
                this.remote_fn()
                this.$message({showClose: true,message: '设置远程地址成功',type: 'success'});
              } else {
                res.message? this.$message.error(res.message):this.$message.error('设置远程地址失败')
              }
            })


          } else {
            return false;
          }
        });
      },
      //禁用跟启用
      remoteStatus (type) {
        var d={
          dateStatus: type,
          id: this.remote.id
        }
        var str=type=='ENABLE'? '启用':'禁用'
        capacityStatusRemote(d).then(res => {
          if(res.code==200) {
            this.dialogAddress=false
            this.remote_fn()
            this.$message({showClose: true,message: `${str}成功`,type: 'success'});
          } else {
            res.message? this.$message.error(res.message):this.$message.error(`${str}失败`)
          }
        })
      },

      //启用
      switch_fn (val,row) {
        var dateStatus=val? 'ENABLE':'DISABLE'
        var tip=val? '启用':'禁用'
        mappingStatus({'dateStatus': dateStatus,'id': row.id}).then(res => {
          console.log(res);
          if(res.code==200) {
            if(val) {
              this.$message({showClose: true,message: `${row.capacityName} 启用成功`,type: 'success'});
            } else {
              this.$message({showClose: true,message: `${row.capacityName} 禁用成功`,type: 'warning'});
            }
          } else {
            this.$message.error(`${row.capacityName} ${tip}失败`);
          }
        })
      },
      // 添加弹窗
      add_ed (v,l) {
        // this.temp = {}
        if(this.nowVirtualDevice!=undefined) {
          this.temp={
            "localDevices": this.nowVirtualDevice.name,
            "localDeviceNos": this.nowVirtualDevice.no,
          }
        }

        //  this.temp.capacityName = ''
        this.dialogStatus='add';
        this.dialogVisible=true;
        this.topLevel=v
        this.$nextTick(() => {
          this.$refs.elradiotree.setNowDefaultDevice(this.temp.localDeviceNos)
          this.$refs["temp"].clearValidate();
        });
        // this.temp = { EnergyTypeParentId: v || null};
      },
      // 确认添加
      add_fn (formName) {
        this.$refs[formName].validate(valid => {
          if(valid) {
            this.temp.unitId=this.unitId.id
            setMappingSave(this.temp).then(res => {
              if(res.code==200) {
                this.getList();
                this.dialogVisible=false;
                this.$message({showClose: true,message: '添加成功',type: 'success'});
              } else {
                if(res.message) {
                  this.$message.error(res.message);
                } else {
                  this.$message.error('添加失败');
                }
              }
            })


          } else {
            return false;
          }
        });
      },

      // 确认编辑
      edit_fn () {
        this.$refs['temp'].validate(valid => {
          if(valid) {
            var data=this.temp
            var d={
              "capacityName": data.capacityName,
              "localDevices": data.localDevices,
              "localDeviceNos": data.localDeviceNos,
              "measurement": data.measurement,
              "remotDevice": data.remotDevice,
              "id": data.id,
              'unitId': this.unitId.id
            }
            mappingUpdate(d).then(res => {
              if(res.code==200) {
                this.getList();
                this.dialogVisible=false;
                this.$message({showClose: true,message: '修改成功',type: 'success'});
              } else {
                if(res.message) {
                  this.$message.error(res.message);
                } else {
                  this.$message.error('修改失败');
                }
              }
            })
          } else {
            return false;
          }
        });
      },
      //编辑弹窗
      edit_ed (v) {
        this.dialogStatus='edit';

        this.temp=Object.assign({},v);

        this.dialogVisible=true;

        this.$nextTick(() => {
          this.$refs["temp"].clearValidate();
          this.$refs.elradiotree.setNowDefaultDevice(this.temp.localDeviceNos)
        });

      },
      //下载表格excel
      exportList () {
        let time=new Date();
        let year=time.getFullYear();
        let month=time.getMonth()+1;
        let day=time.getDate();

        const tHeader=[];
        this.$refs.downloadTable.export2Excel(tHeader,this.tableData,year+"-"+month+"-"+day+'-映射管理','.mapping-table')
      },
      // 转换时间戳
      date_format_fn (value) {
        if(!value) {
          return ""
        }
        let date=new Date(value);
        let Y=date.getFullYear()+'-';
        let M=(date.getMonth()+1<10? '0'+(date.getMonth()+1):date.getMonth()+1)+'-';
        let D=(date.getDate()<10? '0'+(date.getDate()):date.getDate())+' ';

        let h=(date.getHours()<10? '0'+(date.getHours()):date.getHours())+':';
        let m=(date.getMinutes()<10? '0'+(date.getMinutes()):date.getMinutes())+':';
        let s=(date.getSeconds()<10? '0'+(date.getSeconds()):date.getSeconds());
        let strDate=Y+M+D+h+m+s;
        return `'${strDate}'`
      },


    },
    filters: {
      // 转换时间戳
      "date_format": function(value) { //value就是插值的数据
        if(!value) {
          return ""
        }
        let date=new Date(value);
        let Y=date.getFullYear()+'-';
        let M=(date.getMonth()+1<10? '0'+(date.getMonth()+1):date.getMonth()+1)+'-';
        let D=(date.getDate()<10? '0'+(date.getDate()):date.getDate())+' ';

        let h=(date.getHours()<10? '0'+(date.getHours()):date.getHours())+':';
        let m=(date.getMinutes()<10? '0'+(date.getMinutes()):date.getMinutes())+':';
        let s=(date.getSeconds()<10? '0'+(date.getSeconds()):date.getSeconds());
        let strDate=Y+M+D+h+m+s;
        return strDate
      },
    }
  };
</script>

<style lang="scss" scoped>
  .mapping {
    width: 100%;
    // height: calc(100% - 125px) !important;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px;

    .content {
      width: 100%;
      height: 100%;
      background-color: #fff;
      padding: 12px 20px;
      box-sizing: border-box;

      .mapping-table {
        /deep/.el-table th.is-leaf {
          border-bottom: 0px;
        }

        .buttoned_box {
          display: flex;
          justify-content: center;
          align-items: center;

          .line {
            display: inline-block;
            width: 1px;
            height: 20px;
            background-color: #E6E6E6;
            margin: 0px 20px;
          }

          .buttoned {
            cursor: pointer;
          }

          /deep/.el-button span {
            font-size: 15px;
            font-weight: 400;
          }
        }
      }

    }

    .newtable-title {


      display: flex;
      // align-items: center;
      justify-content: space-between;
      margin-bottom: 10px;
    }

    /deep/.el-dialog__header {
      display: flex;
      align-items: center;
      border-bottom: 1px solid #f5f5f5;

      span {
        color: #67A3ED;
        font-size: 16px;
      }

      .el-icon-close {
        font-size: 22px !important;
      }

    }

    /deep/.el-dialog__footer {
      margin-top: 20px;
      text-align: right !important;
      border-top: 1px solid #f5f5f5;

      button {
        padding: 8px 17px;
      }
    }

    /deep/.el_Tree_Body {
      height: 99.5%;
    }

    .demo-temp {
      display: flex;
      flex-wrap: wrap;
    }

    /deep/.el-form-item {
      display: flex;
      margin-left: 20px;
    }

    .address {
      /deep/.el-form-item__content {
        width: 100%;
        display: flex;
        align-items: center;
      }

      button {
        height: 34px;
      }
    }

    .device-tree {
      height: 100%;
    }

    /deep/.el-form-item__label {
      white-space: nowrap;
    }

    /deep/.el-dialog__body {
      padding: 20px 0px 0px 20px !important;
    }

    /deep/.el-input__inner {
      height: 34px;
      line-height: 34px;
    }
  }
</style>